import { forwardRef, useMemo, type ComponentPropsWithoutRef } from 'react';
import { IconChevronDown } from '@tabler/icons-react';
import classNames from 'classnames';
import { useFela } from 'react-fela';

import * as felaRules from './DropdownButton.rules';

export interface DropdownButtonProps extends ComponentPropsWithoutRef<'button'> {
    open?: boolean;
    customStyle?: typeof felaRules.button;
}

export const DropdownButton = forwardRef<HTMLButtonElement, DropdownButtonProps>(
    ({ children, open, className, customStyle, ...rest }, ref) => {
        const isPopoverOpen = useMemo(() => {
            if (typeof open === 'boolean') {
                return open;
            }

            if (className?.includes('ant-popover-open') || className?.includes('ant-dropdown-open')) {
                return true;
            }

            return false;
        }, [open, className]);

        const { css } = useFela({ dropdownOpen: isPopoverOpen });

        return (
            <button
                ref={ref}
                {...rest}
                className={classNames(css(felaRules.button, customStyle), className)}
                onClick={e => {
                    e.preventDefault();
                }}
            >
                {children}
                <IconChevronDown size={16} className={css(felaRules.caret)} />
            </button>
        );
    },
);
